<script>
	import SongEntry from './songentry.svelte';

	export let data;
	export let params;
</script>

<ul class="roundBox" style:background-color={data.category.color}>
{#each data.sorted as song}
	{#if (!params.search || song.match(params.search))}
	<SongEntry
		bind:song={song}
		showScore={params.config.showScore}
		on:setActSong
		on:deleteSong
	/>
	{/if}
{/each}
</ul>
